import { Link } from "react-router-dom";
import { Button } from "antd";
import classNames from "classnames";

import { LayerType } from "@/app/routing/types";
import { UIFlatIcon } from "@/shared/ui/ui-flat-icon";

import { useMoveLayer } from "./hooks";

interface BackLayerButtonProps {
	layer: LayerType;
	isOpenMenu?: boolean;
}

export const BackLayerButton = ({ isOpenMenu = false, layer }: BackLayerButtonProps) => {
	const moveLayer = useMoveLayer(layer);

	if (!moveLayer) return null;

	return (
		<div className="m-4 mb-12">
			<Link to={moveLayer}>
				<Button
					type="text"
					icon={<UIFlatIcon name="fi-rr-arrow-left" tokenColor="colorIcon" />}
					className={classNames("h-40 pl-24 pr-16 justify-start")}
					style={{ width: "100%" }}
				>
					<span
						style={{
							transition: "all 0.3s",
							overflow: "hidden",
							maxWidth: isOpenMenu ? "100%" : 0,
						}}
					>
						Back to previous
					</span>
				</Button>
			</Link>
		</div>
	);
};
